<template>
  <div>
    <Header></Header>
    <div id="main">

      <div class="container">
        <div class="row">
          <div class="col-md-12">

            <h1 v-if="project">{{project.Info.title}}</h1>

            <div class="section-tab">
              <ul>
                <li>1 - Quanto quero doar</li>
                <li>2 - Meios de pagamento</li>
                <li class="active">3 - Compartilhar</li>
              </ul>
            </div>

            <div class="payment-method">
              <h2 v-if="donation && !donation.paymentMethod == 'boleto'">Obrigado pela sua doação!</h2>
              <h2 v-if="donation && donation.paymentMethod == 'boleto'">Clique no link abaixo para ver o boleto</h2>
              <button v-if="donation && donation.paymentMethod == 'boleto'"
               class="btn" v-on:click.stop.prevent="generateBoleto()">Visualizar Boleto</button>
            </div>

            <div class="share-project">
              <h4>Compartilhe essa Organização Social!</h4>
              <p>Multiplique a chance de um projeto receber doações. Compartilhe sua doação.</p>
              <button class="btn" v-on:click.stop.prevent="shareFacebook()">Compartilhe este Projeto <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></button>
            </div>

          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import auth from '../services/auth'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import Loading from './includes/Loading'
import Functions from '../utils/functions'
import { API } from '../services/api'

export default {
  name: 'DonationFinish',
  components: {
    Header,
    Footer,
    Loading,
    FontAwesomeIcon
  },
  data () {
    return {
      loading: true,
      donation: null,
      project: null,
      hasPagarme: false,
      hasPagseguro: false,
      hasPaypal: false
    }
  },
  mounted(){
    this.loadProfile();
    this.loadDonation();
  },
  methods: {
    loadProfile(){
      if(auth.isAuth()){
        this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
          this.user = response.body.user;
        }, (err) => {
          this.$router.push('/project/' + this.$route.params.slug);
        });
      }
    },
    loadDonation(){
      this.$http.get(API.Projects.getDonation + this.$route.params.DonationId, {headers: auth.getHeaders()}).then((res) => {
        this.donation = res.body;
        // if(this.donation.paymentStatus == 'paid'){
          // this.$router.push('/profile/my-projects');
        // }
        this.loadProject()
      }, (err) => {
        this.$router.push('/profile/my-donations');
      });
    },
    loadProject(){
      this.$http.get(API.Projects.getProject + this.donation.ProjectId, {headers: auth.getHeaders()}).then((res) => {
        this.project = res.body[0]
        this.loading = false;
      }, (err) => {
        this.$router.push('/profile/my-projects');
      });
    },
    generateBoleto(){
      var postback = JSON.parse(this.donation.postback);
      if(postback.boleto_url){
        window.open(postback.boleto_url);
      }else if(postback['transaction%5Bboleto_url%5D']){
        window.open(decodeURIComponent(postback['transaction%5Bboleto_url%5D']));
      }else{
        window.open(postback.current_transaction.boleto_url);
      }
    },
    shareFacebook(){
      window.open("https://www.facebook.com/sharer/sharer.php?u=https://click2giv.com/#/project/" + this.project.slug);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #main{
    padding-bottom: 90px;
  }
  h1{
    text-align: center;
    font-family: RalewayBold;
    color: #00ae39;
  }

  .section-tab{
    width: 100%;
    margin-top: 20px;

    ul{
      list-style: none;
      padding: 0;
      padding-top: 20px;
      border-bottom: thin solid #ccc;

      li{
        display: inline-block;
        padding-bottom: 10px;
        margin-right: 20px;
        font-size: 20px;
        @media screen and(max-width: 767px){
          display: none;
          margin-right: 0px;
        }
        cursor: default;
        &.active{
          color: #00ae39;
          font-weight: bold;
          border-bottom: 3px solid #00ae39;
          @media screen and(max-width: 767px){
            display: block;
            text-align: center;;
          }
        }
      }
    }
  }

  .payment-method{
    margin-top: 30px;
    text-align: center;
    padding-bottom: 30px;
    h2{
      font-family: RalewayRegular;
    }
    button{
      font-size: 22px;
      color: #fff;
      background-color: #00ae39;
      padding: 10px;
    }
  }

  .share-project{
    width: 100%;
    height: auto;
    text-align: center;
    margin-top: 30px;
    button{
      background-color: #3b5998;
      color: #fff;
      font-size: 22px;
    }
  }

  h5{
    position: relative;
    text-align: center;
    margin: 30px 0px;
    font-family: RalewayRegular;

    &::before{
      position: absolute;
      content: " ";
      width: 35%;
      border-bottom: 1px solid #d9d9d9;
      height: 1px;
      top: 50%;
      right: 0;
    }

    &::after{
      position: absolute;
      content: " ";
      width: 35%;
      border-bottom: 1px solid #d9d9d9;
      height: 1px;
      top: 50%;
      left: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/DonationFinish.vue